import { formatDate } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { LocalizationService } from '@degreed/lxp/services';
import { TranslateService } from '@ngx-translate/core';
import { TriggerSchedule, TriggerScheduleType } from '../model';
import { getDayOfWeek } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class TriggerScheduleService {
  private translate = inject(TranslateService);
  private localizationService = inject(LocalizationService);

  public getScheduleDescription(schedule: TriggerSchedule): string {
    let formattedString = '';
    const cadence = this.translate.instant(
      `Automation_Schedule_${schedule.scheduleType}`
    );

    switch (schedule.scheduleType) {
      case TriggerScheduleType.Daily: // Run Daily (weekdays) at {{time}} (UTC)
        formattedString = this.translate.instant(
          'Automation_CadenceDailyTime_Format',
          {
            time: schedule.executionTime,
          }
        );
        break;
      case TriggerScheduleType.Weekly: // Run Weekly on {{dayOfWeek}} at {{time}} (UTC)
        formattedString = this.translate.instant(
          'Automation_CadenceDateTime_Format',
          {
            cadence,
            date: this.translate.instant(
              `Core_DayOfWeek${getDayOfWeek(schedule.day)}`
            ),
            time: schedule.executionTime,
          }
        );
        break;
      case TriggerScheduleType.Monthly: // Run Monthly on the {{dayOfMonth}} day at {{time}} (UTC)
        formattedString = this.translate.instant(
          'Automation_CadenceDayOfTime_Format',
          {
            cadence,
            date:
              schedule.day === -1
                ? this.translate.instant('Automation_Schedule_Last')
                : this.translate.instant(
                    `Automation_Schedule_Ordinal_${schedule.day}`
                  ),
            time: schedule.executionTime,
          }
        );
        break;
      case TriggerScheduleType.Once: // Run Once on {{specifiedDate}} at {{time}} (UTC)
        formattedString = this.translate.instant(
          'Automation_CadenceDateTime_Format',
          {
            cadence,
            date: schedule.specifiedDate
              ? formatDate(
                  schedule.specifiedDate,
                  'mediumDate',
                  this.localizationService.userLocale
                )
              : '',
            time: schedule.executionTime,
          }
        );
    }
    return formattedString;
  }
}
